import { inject } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { ActivityRecommendations } from '@shared-ui/local-expert-activities';
import { useBexApi } from '@shared-ui/bex-api-context';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { MultiItemStore } from 'src/common/stores/multi-item-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { DateUtils } from 'utils/date-utils';

import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

interface ActivityRecommendationsWrapperProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
}

export const ActivityRecommendationsWrapper: React.FunctionComponent<ActivityRecommendationsWrapperProps> = inject(
  'currentHotel',
  'multiItem'
)(({ currentHotel, multiItem }) => {
  const { context: bexContext } = useBexApi();
  const { offerSearchData } = currentHotel || {};

  const startDate = offerSearchData?.startDate && DateUtils.parseDateString(offerSearchData.startDate);
  const endDate = offerSearchData?.endDate && DateUtils.parseDateString(offerSearchData.endDate);
  const dateRanges =
    startDate && endDate
      ? {
          startDate: startDate,
          endDate: endDate,
        }
      : null;

  const isMultiItem = multiItem?.isPackageShoppingPath();

  return (
    <ErrorBoundary label="hotel.information.activities">
      <>
        {bexContext && currentHotel?.hotelId && !isMultiItem && (
          <SimpleLazyLoadWrapper placeholder={<div data-stid="recommended-activities__placeholder" />}>
            <UitkSpacing padding={{ small: { inline: 'three' }, medium: { inline: 'unset' } }}>
              <div>
                <ActivityRecommendations
                  inputs={{
                    destination: {
                      regionId: String(currentHotel.hotelId),
                      regionType: 'hotel',
                    },
                    dateRange: dateRanges,
                    searchViewOptions: ['TRAVEL_DISTANCE_FROM_HOTEL' as any],
                  }}
                  skipSsr={true}
                />
              </div>
            </UitkSpacing>
          </SimpleLazyLoadWrapper>
        )}
      </>
    </ErrorBoundary>
  );
});
